import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import InquiryDetail from '../components/message/InquiryDetail';
import Notification from '../components/message/Notification';
import SetUserDetail from '../components/settings/SetUserDetail';
import SetUserList from '../components/settings/SetUserList';
import VODvoucher from '../components/voucher/VODvoucher';
import { MenuList, SubMenuList } from '../constants/menu';
import MainLayout from '../layouts/MainLayout';
import NotFound from '../pages/404';
import Home from '../pages/Home';
import Login from '../pages/Login/Login';
import SignUp from '../pages/sign-up';
import Username from '../pages/sign-up/username-password-request/username';
import Password from '../pages/sign-up/username-password-request/password';
import { MainMenuWrapper, SubMenuWrapper } from './PermissionWrapper';
import { UpdateProvider } from '../context/UpdateContext';
import TermCondition2 from '../pages/sign-up/TermCondition2';

function Routing() {
  return (
    <BrowserRouter>
      <UpdateProvider>
        <Routes>
          <Route path="" element={<Home />} />
          <Route element={<NotFound />} />
          <Route path="/login" element={<Login />} />
          <Route path="sign-up" element={<SignUp />} />
          <Route path="username" element={<Username />} />
          <Route path="password" element={<Password />} />
          <Route path="privacy" element={<TermCondition2 />} />
          {MenuList.flatMap((menu, i) => {
            if (menu.subMenus.length > 0) {
              return menu.subMenus.map((sub, j) => (
                <Route
                  key={`${i}-${j}`}
                  path={sub.path?.trim()}
                  element={
                    <MainLayout>
                      <MainMenuWrapper path={sub.path?.trim()}>
                        <sub.component />
                      </MainMenuWrapper>
                    </MainLayout>
                  }
                />
              ));
            } else {
              return (
                <Route
                  key={i}
                  path={menu.path?.trim()}
                  element={
                    <MainLayout>
                      <MainMenuWrapper path={menu.path?.trim()}>
                        <menu.component />
                      </MainMenuWrapper>
                    </MainLayout>
                  }
                />
              );
            }
          })}

          {SubMenuList.flatMap((menu, i) => {
            return (
              <Route
                key={i}
                path={menu.path?.trim()}
                element={
                  <MainLayout>
                    <SubMenuWrapper path={menu.path?.trim()} access={menu.accessType}>
                      <menu.component />
                    </SubMenuWrapper>
                  </MainLayout>
                }
              />
            );
          })}

          <Route
            path="/vodvoucher"
            element={
              <MainLayout>
                <VODvoucher />
              </MainLayout>
            }
          />

          <Route
            path="/inquiryDetail"
            element={
              <MainLayout>
                <InquiryDetail />
              </MainLayout>
            }
          />
          <Route
            path="/notification"
            element={
              <MainLayout>
                <Notification />
              </MainLayout>
            }
          />

          <Route
            path="/operators"
            element={
              <MainLayout>
                <SetUserList />
              </MainLayout>
            }
          />
          <Route
            path="/operator"
            element={
              <MainLayout>
                <SetUserDetail />
              </MainLayout>
            }
          />
          <Route
            path="/operator/:id"
            element={
              <MainLayout>
                <SetUserDetail />
              </MainLayout>
            }
          />
        </Routes>
      </UpdateProvider>
    </BrowserRouter>
  );
}

export default Routing;
